import { render } from "./BaseWidget.vue?vue&type=template&id=8d375742&scoped=true"
const script = {}

import "./BaseWidget.vue?vue&type=style&index=0&id=8d375742&scoped=true&lang=css"

import exportComponent from "/home/windows/Documents/workspace/proxyscrape-project/proxyscrape-website-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d375742"]])

export default __exports__